export enum ProposalStage {
    Draft = 1,
    NotRequired = 2,
    ReadyToReview = 3,
    Signed = 4,
    SentToClient = 5,
    Instructed = 6,
    Invoiced = 7,
    Paid = 8,
    Closed = 9,
}